import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './folders_dropdown_create_text.module.scss';

export const FoldersDropdownCreateText: FC = () => (
  <div className={styles.container}>
    <FormattedMessage id="folders/create/FoldersDropdownCreateText.tsx/1" />
  </div>
);
